<template>
	<router-link :to="{ name: 'base-stations-edit', params: { id: baseStation.id } }">
		<NoLineBreaks class="flex-wrapper gap-sm">
			<MountpointDisplay :baseStation="baseStation" />
			<TypographyText>{{ baseStation.label }}</TypographyText>
		</NoLineBreaks>
	</router-link>
</template>

<script>
import { TypographyText } from 'ant-design-vue';

import MountpointDisplay from '@/components/baseStations/MountpointDisplay.vue';
import NoLineBreaks from '@/components/common/NoLineBreaks';

export default {
	components: {
		TypographyText,
		MountpointDisplay,
		NoLineBreaks,
	},
	props: ['baseStation']
}
</script>

